import React, { useContext } from 'react'
import 'materialize-css'
import { useHistory } from 'react-router-dom'
import { Row, Col, Button, Collection, CollectionItem, Icon } from 'react-materialize'
import { GlobalContext } from '../context/GlobalState'


export const EsitoButtons = ({ idCart }) => {
    const { 
        svuotaCarrello,
        saveContext,
    } = useContext(GlobalContext);

    const history = useHistory()

    const torna = () => {
        history.push(`/carrello?idCarrello=${idCart}`)
    }

    const svuota = () => {
        svuotaCarrello()
        saveContext()
        history.push('/')
    }

    return (
        <>
            <Row>
                <Col s={12}>
                    <p>Puoi tornare al carrello e ripetere il pagamento.</p>
                    <p>Oppure puoi svuotare il carrello ed effettuare nuovamente il pagamento in un secondo momento.</p>
                    <h5>Come effettuare il pagamento in un secondo momento?</h5>
                    <p>Puoi procedere in uno dei seguenti modi:</p>
                    <Collection>
                        <CollectionItem><Icon>check</Icon> Puoi segnarti il <b>Codice Fiscale Ente Creditore</b> e il <b>Codice Avviso</b> ed effettuare il pagamento sul portale di <a href="https://checkout.pagopa.it" target='_blank'><b>CHECKOUT</b></a> di PagoPA</CollectionItem>
                        <CollectionItem><Icon>check</Icon> Accedere al tuo profilo tramite SPID/CIE per scaricare gli avvisi di pagamento o pagare direttamente dalla tua area personale</CollectionItem>
                        <CollectionItem><Icon>check</Icon> Utilizzare l'app IO per visualizzare i propri avvisi di pagamento e procedere al pagamento</CollectionItem>
                    </Collection>
                </Col>
            </Row>
            <Row>
                <Col s={12} l={6}>
                    <Button large style={{width:'100%'}} waves='light' onClick={torna}>Torna al carrello</Button>
                </Col>
                <Col s={12} l={6}>
                    <Button large style={{width:'100%'}} waves='light' onClick={svuota}>Svuota il carrello</Button>
                </Col>
            </Row>
        </>
    );
}